'use client'

import { ReactNode, useMemo } from 'react'

import { StagingAuthModal } from 'Components/Blocks/Modals'
import { IS_STAGING, STAGING_AUTH } from 'Config'

import { useStagingAuth } from 'Services/Store/StagingAuth'

type Props = {
  children?: ReactNode
}

function StagingGate({ children }: Props) {
  const { login, password } = useStagingAuth()

  const isAuthorized = useMemo(
    () =>
      login === STAGING_AUTH.BASIC_AUTH_USER &&
      password === STAGING_AUTH.BASIC_AUTH_PASS,
    [login, password],
  )

  if (IS_STAGING) {
    if (!isAuthorized) return <StagingAuthModal isOpened />
  }

  return children
}

export default StagingGate
